export const API_COOKIE_NAME = 'gov.cms.eapd.api-token';
export const CONSENT_COOKIE_NAME = 'gov.cms.eapd.hasConsented';
